const { regClass, property } = Laya;
import GameLevel from "./GameLevel";
import ToyProto from "./ToyProto";
import * as consts from "./const";
import {DataCenter} from "../DataCenter";
import * as Anim from "./Anim";

export enum TOY_STATE {
    STATIC = 0
    ,DROP = 1
    ,MATCHING = 2
    ,MATCHED = 3
    ,LOCKED = 4
    //RELAXED = 5
}

@regClass('hIXP-u9_RfeIwPLhNGNjGw')
export default class Toy extends Laya.Script {
    public state: TOY_STATE = TOY_STATE.STATIC;
    public _toyProto: ToyProto;
    public _srcProto: ToyProto;
    public _isThunder: boolean = false;
    public _oX: number = 0;
    public _oY: number = 0;

    public _delta: number = 0;
    public _lastY: number = 0;
    public _lastX: number = 0;
    public _id:string = "";
    public _inPot:boolean = false;
    public _last_other:any = null;
    public _last_playSoundTime: number = 0;

    constructor() { super(); }

    set toyProto(value: ToyProto) {
        this._toyProto = value;
        this._srcProto = null;
    }
    get toyProto(): ToyProto {
        return this._toyProto;
    }
    
    canMatch(toy:Toy): boolean {
        if(this.state == TOY_STATE.MATCHED)
            return false;
        if(toy.state == TOY_STATE.MATCHED)
            return false;
        if(this._srcProto)
            return false;
        if(toy._srcProto)
            return false;
        return this._toyProto == toy._toyProto;
    }
    canforceMatch(toy:Toy): boolean {
        if(this.state == TOY_STATE.MATCHED)
            return false;
        if(toy.state == TOY_STATE.MATCHED)
            return false;
        let myProto = this._toyProto;
        if(this._srcProto)
            myProto = this._srcProto;
        let toyProto = toy._toyProto;
        if(toy._srcProto)
            toyProto = toy._srcProto;
        return myProto == toyProto;
    }

    onEnable(): void {
    }

    onTriggerEnter(other: any, self: any, contact: any): void {
        if(!GameLevel.instance._started) {
            return;
        }
        const otherToy = other.owner.getComponent(Toy); 
        if(this._last_other != other) {     
            let now = Laya.timer.currTimer;
            if((now - this._last_playSoundTime) > 550 &&this.state != TOY_STATE.MATCHED)
            {
                if(otherToy == null || otherToy.state != TOY_STATE.MATCHED) {
                    if(consts.MODE_XMAS == DataCenter.instance.level_mode)
                        consts.playSound("resources/cdn/x.mp3");
                    else
                        consts.playSound("resources/cdn/gem.mp3");
                    this._last_playSoundTime = now;
                }
            }
        }
        this._last_other = other;
        if(this.state !== TOY_STATE.MATCHING) {
            return;
        }

        let sprite = this.owner as Laya.Sprite;
        let h  = GameLevel.instance.getMatchY();
        if (sprite.y <= h) {
            return;
        }
        if(sprite.x < consts.MATCH_LEFT || sprite.x > consts.MATCH_RIGHT) {
            return;
        }
        if (otherToy && otherToy.state === TOY_STATE.MATCHING) {

            // 比较两个toyProto是否相同
            if (this.canMatch(otherToy)) {
                let otherSprite = other.owner as Laya.Sprite;

                if(otherSprite.x < consts.MATCH_LEFT || otherSprite.x > consts.MATCH_RIGHT) {
                    return;
                }
                if (otherSprite.y < h) {
                    return;
                }
                GameLevel.instance.matched(sprite, otherSprite);
            }
        }
    }

    onUpdate(): void {
        let sprite = this.owner as Laya.Sprite;   
        if (this.state === TOY_STATE.STATIC) {
            return;
        }
        else if (this.state === TOY_STATE.DROP) {
            let matchY = GameLevel.instance.getMatchY();
            this._delta = Math.abs(sprite.y - this._lastY) + Math.abs(sprite.x - this._lastX);
            this._lastX = sprite.x; 
            this._lastY = sprite.y;

            if (sprite.y > matchY) {
                GameLevel.instance._matchingToys.push(sprite);
                //GameLevel.instance._dynamicBox.addChild(sprite);

                this.state = TOY_STATE.MATCHING;
                if (this._srcProto) {
                    

                    //this.setProto(this._srcProto);
                    //this._srcProto = null;
                    GameLevel.instance.changeToy(this, this._srcProto);
                }
            }

            return;
        }
        else if (this.state === TOY_STATE.MATCHING) {         
            this._delta = Math.abs(sprite.y - this._lastY) + Math.abs(sprite.x - this._lastX);
            this._lastX = sprite.x; 
            this._lastY = sprite.y;
        }
        else if (this.state === TOY_STATE.MATCHED) {
            if (sprite.y > Laya.stage.height + 200) {

                //this.owner.removeSelf();
                let sprite = this.owner as Laya.Sprite;
                sprite.destroy();
                
            }
        }
        if (this._lastY > Laya.stage.height * 3) {
            sprite.x = 300;
            sprite.y = 500;
        }

    }

    onDisable(): void {
        //Laya.Pool.recover("toy", this.owner);
    }

    setToyLocked(locked: boolean) {

        this.state = locked ? TOY_STATE.LOCKED : TOY_STATE.STATIC;
        if (locked) {
            let a = this.owner as Laya.Image;
            a.color = "7f7f7f";
        }
        else {
            let a = this.owner as Laya.Image;
            a.color = "ffffff";
        }
    }

    enableCollider(enable:boolean) {
        let toy = this.owner as Laya.Image;
        let colliders = toy.getComponents(Laya.ColliderBase);
        for(let c of colliders) {
            let collider = c as Laya.ColliderBase;
            collider.isSensor = !enable;
        }
    }

    static setToyImage(img:Laya.Image, toyProto: ToyProto) {
        let style = toyProto.style;
        //console.log(img.name)
        //console.log(img.parent.name);
        //console.log("setToyImage");
        
        if(style.skin_id >= 0) {
            let index = toyProto.shape_id * 4 + style.skin_id;
            img.skin = GameLevel.instance.toySkins[index].url;
        }
        else{
            let index = toyProto.shape_id * 4;
            let url = GameLevel.instance.toySkins[index].url
            img.skin = url.replace("_black", "");

        }
        if(style.mat_id >= 0) {
            img.material = GameLevel.instance.mats[style.mat_id];
        }
        
        if(toyProto.hasEdge) {
            let edge = img.getChildAt(0) as Laya.Image;
            
            let index = toyProto.shape_id * 4 + 1;    
            edge.skin = GameLevel.instance.toySkins[index].url;
        }
    }


    initToy(toyProto: ToyProto):Laya.RigidBody {
        this._toyProto = toyProto;
        let toy = this.owner as Laya.Image;
        
        let style = toyProto.style;
        if(style.skin_id >= 0) {
            let index = toyProto.shape_id * 4 + style.skin_id;
            toy.skin = GameLevel.instance.toySkins[index].url;
        }

        if(style.mat_id >= 0) {
            toy.material = GameLevel.instance.mats[style.mat_id];
        }
        
        if(toyProto.hasEdge) {
            let edge = null;
            if(toy.numChildren == 0)
            {
                edge = new Laya.Image();
                toy.addChild(edge);
            }
            else
                edge = toy.getChildAt(0) as Laya.Image;

            let index = toyProto.shape_id * 4 + 1;    
            edge.skin = GameLevel.instance.toySkins[index].url;
        }
        else
        {
            if(toy.numChildren > 0)
                toy.removeChildren();
        }
        
        //this.toyProto = toyProto;
        this._delta = 0;
        this._lastY = toy.y;
        this._lastX = toy.x;
        //toyScript.setToyLocked(true);
        
        let rig: Laya.RigidBody = toy.getComponent(Laya.RigidBody);
        rig.setVelocity({ x: 0, y: 0 });
        rig.angularVelocity = 0;
        rig.angularDamping = 0;
        rig.enabled = true;
        rig.type = "dynamic";
        rig.gravityScale = consts.gravity;
        rig.allowSleep = true;


        return rig;

    }

}